module.exports = __webpack_public_path__ + "static/img/file-swf.be2f2c67.svg";